// Libs
import React, { useEffect, useState } from "react";
import { Avatar, Badge, Col, Dropdown, Layout, Row, Select, Spin } from "antd";
import { useAuth0 } from "@auth0/auth0-react";
import { useParams, useNavigate } from "react-router-dom";

// Components
import DashboardHeaderDropdown from "./dropdown";
import MainButton from "components/libs/button";

// Hooks
import { useSDKUsers } from "hooks/user-sdk";

// Icons
import { BellOutlined, PlusSquareOutlined } from "@ant-design/icons";

// Styles
import s from "./index.module.scss";
import DashboardCreateTenantModal from "./create-tenant-modal";

const { Header } = Layout;

function DashboardLayoutHeader() {
  const { user } = useAuth0();
  const navigate = useNavigate();
  const params = useParams();

  //#region  User hooks
  const { data: userDetails, loading } = useSDKUsers({
    externalUserId: user?.sub,
  });
  const defaultTenant = userDetails?.tenants?.find(
    (item) => item.defaultTenant
  );
  //#endregion

  //#region  Handle Select
  const handleSelectTenant = async (value) => {
    localStorage.setItem("tenant-name", value);
    navigate(`/dashboard/${value}`);
  };
  //#endregion

  //#region  Handle Create Tenant Modal
  const [createTenantModal, setCreateTenantModal] = useState(false);
  const handleCreateTenantModal = () => {
    setCreateTenantModal(!createTenantModal);
  };
  //#endregion

  //#region Handle current tenant
  const [currentTenant, setCurrentTenant] = useState();
  useEffect(() => {
    setCurrentTenant(params.tenant);
  }, [params.tenant]);
  //#endregion

  const menuItem = DashboardHeaderDropdown();

  return (
    <>
      <Header className={`${s.header}`}>
        <Row justify="end" gutter={[16, 0]}>
          <Row className={`${s.container}`}>
            <Col>
              <Select
                style={{ minWidth: 200 }}
                dropdownStyle={{ padding: 0 }}
                popupMatchSelectWidth={true}
                listHeight={128}
                onChange={handleSelectTenant}
                options={userDetails?.tenants?.map((item) => {
                  return {
                    label: `${item.displayName} ${
                      item.tenantId === defaultTenant.tenantId
                        ? "(default)"
                        : ""
                    }`,
                    value: item.tenantName,
                    disabled: item.tenantName === params.tenant,
                  };
                })}
                value={currentTenant}
                dropdownRender={(menu) => {
                  return (
                    <>
                      <Spin spinning={loading}>{menu}</Spin>
                      <Col
                        span={24}
                        style={{
                          paddingRight: 0,
                          paddingLeft: 0,
                        }}
                      >
                        <MainButton
                          type="dashed"
                          style={{
                            padding: "5px 15px",
                            width: "100%",
                            borderRadius: "0px",
                            fontSize: "14px",
                          }}
                          onClick={handleCreateTenantModal}
                        >
                          <span
                            style={{
                              marginRight: 5,
                              top: "-3px",
                              position: "relative",
                            }}
                          >
                            <PlusSquareOutlined />
                          </span>
                          Create Tenant
                        </MainButton>
                      </Col>
                    </>
                  );
                }}
              />
            </Col>
          </Row>
          <Row className={`${s.container}`} gutter={[16, 0]}>
            <Col className={s.notification}>
              <Badge dot>
                <BellOutlined />
              </Badge>
            </Col>
            <Col className={s.avatarContainer}>
              <Dropdown
                menu={{ items: menuItem }}
                placement="bottomRight"
                arrow
              >
                <Avatar
                  size="default"
                  className={s.avatar}
                  src={user?.picture}
                />
              </Dropdown>
            </Col>
          </Row>
        </Row>
      </Header>

      {createTenantModal && (
        <DashboardCreateTenantModal
          isShow={createTenantModal}
          onCancel={handleCreateTenantModal}
        />
      )}
    </>
  );
}

export default DashboardLayoutHeader;
